import { fetchJson } from "src/utils/apiUtils";
import {
  ISerialNoMappingItem,
  ISerialNoUploadReq,
  ISSWUploadImportReq,
  ISSWUploadImportResp,
  ISSWUploadPreviewReq,
  ISSWUploadPreviewResp
} from "./types";

const endpoint = `uploadData`;

export const uploadPreviewSSW = async (req: ISSWUploadPreviewReq) => {
  return fetchJson<IResponse<ISSWUploadPreviewResp>>(
    `${endpoint}/ssw/uploadPreview`,
    {
      method: "POST",
      body: JSON.stringify({ ...req })
    }
  );
};

export const uploadImportSSW = async (req: ISSWUploadImportReq) => {
  return fetchJson<IResponse<ISSWUploadImportResp>>(
    `${endpoint}/ssw/uploadImport`,
    {
      method: "POST",
      body: JSON.stringify({ ...req })
    }
  );
};

export const listSerialNo = async (partnerId: PartnerId) => {
  return fetchJson<IResponse<ISerialNoMappingItem[]>>(
    `${endpoint}/serialNo/list?partnerId=${partnerId}`,
    {
      method: "GET"
    }
  );
};

export const uploadSerialNo = async (req: ISerialNoUploadReq) => {
  return fetchJson<IResponse<void>>(`${endpoint}/serialNo/upload`, {
    method: "POST",
    body: JSON.stringify({ ...req })
  });
};
